// extracted by mini-css-extract-plugin
module.exports = {"containerWrapper":"styles_containerWrapper__2Xi1J","errorWrapper":"styles_errorWrapper__3Uqll","logoWrapper":"styles_logoWrapper__2x1Id"};